import React from 'react';
import { List } from 'antd';
import UserIcon from '../../svg/UserIcon';
import ColEdit from '../ColEdit/ColEdit';
import ButtonDefault from '../ButtonDefault/ButtonDefault';
import { useNavigate } from 'react-router-dom';

const HomeCart = (props) => {

    const navigate = useNavigate();

    const onNav = (pUrl) => {
        if (pUrl) {
            navigate(pUrl);
        }
    }

    return (
        <div style={{ marginLeft: 16, width: 212, background: '#FFFFFF', border: '1px solid #DDDDDD', boxShadow: '0px 0px 2px rgba(0, 0, 0, 0.1)', borderRadius: 2 }}>
            <div style={{ borderBottom: '1px solid #DDDDDD', padding: 16 }}>
                <div style={{ fontWeight: 400, fontSize: 16 }}>{props?.title}</div>
                <div style={{ display: 'flex', marginTop: 16, alignItems: 'flex-end' }}>
                    <UserIcon />
                    <div style={{ marginLeft: 4, marginRight: 4, marginBottom: -6 }}>
                        <div style={{ fontWeight: 400, fontSize: 26 }}>{props?.data?.length}</div>
                    </div>
                    <div style={{ fontWeight: 400, fontSize: 12, color: '#605E5C' }}>ажилтан</div>
                </div>
            </div>
            <div style={{ padding: 16 }}>
                <List
                    grid={{
                        gutter: [8, 8],
                        xs: 1,
                        sm: 1,
                        md: 1,
                        lg: 1,
                        xl: 1,
                        xxl: 1,
                    }}
                    locale={{ emptyText: "Харуулах мэдээлэлгүй байна" }}
                    dataSource={props?.data}
                    renderItem={(ri) => {
                        return (
                            <div style={{ marginLeft: 8 }} >
                                <ColEdit onClick={() => { props.onClick(ri.key, props?.url) }}>
                                    {ri?.text} {ri?.secondarytext ? ("[" + ri?.secondarytext + "]") : null}
                                </ColEdit>
                            </div>
                        );
                    }}
                />
            </div>
            {props?.url?.indexOf("/hrsuite/employee") >= 0 ? (
                <div style={{ marginLeft: 16, marginRight: 16, marginBottom: 16 }}>
                    <ButtonDefault onClick={() => onNav("/empemplhist")} full text="оруулах" />
                </div>
            ) : null}
        </div>
    );
}

export default HomeCart;